import { validationRules } from '../../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
} from '../../../../../../services/validation/flow/defaultSchemas'

export const webViewTenantHouseRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    plotArea: validationRules.plotArea,
    startRentalDate: validationRules.startRentalDateRequired,
  },
  costs: {
    price: validationRules.price,
    additionalCosts: validationRules.additionalCosts,
    heatingCosts: validationRules.heatingCosts,
    deposit: validationRules.deposit,
  },
  description: defaultDescription,
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
  objectDetails: {
    usableArea: validationRules.usableArea,
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    totalFloorsNumber: validationRules.totalFloors,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
}
